import { render } from "./CounteragentIndex.vue?vue&type=template&id=67be9cf1"
import script from "./CounteragentIndex.vue?vue&type=script&lang=js"
export * from "./CounteragentIndex.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__